import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import StatementsPage, { getDefaultPageUI } from "components/pages/StatementsPage";
import Classes from "model";
import { useEffect } from "react";

export default function CaptureEStatementsExpandedSearch(prop) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ "searchAccordion", "isActive" ], true)
    .update([ "advancedSearch", "isActive" ], true)
    .submit();

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <StatementsPage ui={ ui } />
}